interface TabsProps {
	readonly options: Array<[string, string]>,
	readonly value: string,
	readonly setValue: (fila: string) => void,
	readonly onNew?: () => void;
}

export function VerticalTabs(props: TabsProps) {

	return (
		<div className="tabVertical">
			{props.options.map(([label, value]) => (
				<button key={value} className={`tabLinks ${props.value === value ? "active" : ""}`} onClick={() => props.setValue(value)} type="button">
					{label}
				</button>
			))}

			{props.onNew ? (
				<button className="tabLinks" onClick={props.onNew} type="button">
					+
				</button>
			) : null}
		</div>
	);
}
export function HorizontalTabs(props: TabsProps) {
	return (
		<div className="tabContainer" >
			{props.options.map(([label, value]) => (
				<button key={value} className={props.value === value ? "active" : ""} onClick={() => props.setValue(value)} type="button">
					{label}
				</button>
			))}

			{props.onNew ? (
				<button className="tabLinks" onClick={props.onNew} type="button">
					+
				</button>
			) : null}
		</div>
	);
}
